import styles from "./Paragraph.module.css";

type ParagraphProps = {
  text: string;
  color?: string;
};

export const Paragraph = ({ text, color }: ParagraphProps) => {
  return (
    <div className={styles.text} style={color ? { color } : undefined}>
      {text}
    </div>
  );
};
